import { render, staticRenderFns } from "./AppReviewMediaThumbnailIndicator.vue?vue&type=template&id=222f9860&scoped=true"
import script from "./AppReviewMediaThumbnailIndicator.vue?vue&type=script&lang=js"
export * from "./AppReviewMediaThumbnailIndicator.vue?vue&type=script&lang=js"
import style0 from "./AppReviewMediaThumbnailIndicator.vue?vue&type=style&index=0&id=222f9860&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222f9860",
  null
  
)

export default component.exports